import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import React  from "react";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAddQualificationMutation} from "../../../Services/api";

export default function Create() {
    const validationSchema = Yup.object().shape({
        qualification: Yup.string().required("qualification fields is required"),
    });
    let defaultValues = { name: ""};
    const notify = () => '';
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues,
    });
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = methods;
    const [addQualification,isLoading] = useAddQualificationMutation();
    const onSubmit = (values,e) => {
        addQualification({ data: values })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
    return (
        <div className="tab-pane fade" id="bordered-justified-profile" role="tabpanel" aria-labelledby="profile-tab" >
            <section className="section">
                <div className="card">
                    <div className="card-body">
                    <h5 className="card-title">Add Qualification</h5>
                    <form onSubmit={handleSubmit(onSubmit)} >
                       
                        <div className="row mb-3">
                            <label htmlFor="inputText" className="col-sm-2 col-form-label text-capitalize">Qualification</label>
                            <div className="col-sm-10">
                                <input type="name" {...register("qualification")} className="form-control" />
                                <span className="text-danger">{errors.qualification?.message}</span>
                            </div>
                        </div>
                       
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label"></label>
                            <div className="col-sm-10">
                                  {isLoading.status !='pending' ? 
                                                
                                    <button type="submit" className="btn btn-warning w-100" >Add Qualification</button>
                                    :
                                    <button className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                    }
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
            </section>
        </div>
    );
}